import { getCurrencyMultiplier, isMoneyValue } from '@/lib/moneyUtils';

import type { TaskMoney, TaskUtils } from './types';

const DEFAULT_CURRENCY = 'usd';

export function castToMoney(value: unknown, currency: string = DEFAULT_CURRENCY): TaskMoney {
  if (value === null || value === undefined || value === '') {
    return { amount: 0, currency };
  }

  if (isMoneyValue(value)) {
    return { amount: value.amount, currency: value.currency };
  }

  if (typeof value === 'boolean') {
    return { amount: 0, currency };
  }

  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return { amount: 0, currency };
  }

  return {
    amount: Math.round(numeric * getCurrencyMultiplier(currency)),
    currency
  };
}

export const castUtils: TaskUtils['cast'] = {
  toMoney: (value, currency) => castToMoney(value, currency)
};
